import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { SiteSettings } from '@common/types/site.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class SettingsHttpService extends BaseHttpService {
    public getSiteSettings(siteId: string | number): Observable<SiteSettings> {
        return this.http.get<HttpDataResponse<SiteSettings>>(this.formatApiUrl(`sites/${siteId}/settings`)).pipe(
            shareReplay(),
            map((res) => res.data)
        );
    }
}
